import { render } from "./CreateEdit.vue?vue&type=template&id=017db3d1"
import script from "./CreateEdit.vue?vue&type=script&lang=js"
export * from "./CreateEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__